<template>
  <DragDialog
    :title="title"
    :width="1000"
    :visible.sync="visible"
    :isResize="true"
    :footerBtn="[]"
    :cancel="closeDialog"
    class="file-dialog"
  >
    <div style="height: calc(100% - 64px)">
      <div class="file-table-box">
        <div class="operation-box">
          <div class="common-button-box btn-group-primary">
            <el-button
              v-if="isChecked('Project.Single.Metadata.Bim.Upload')"
              type="primary"
              size="small"
              class="upload-btn primary-btn gr8"
              id="model-group-upload"
              :disabled="isConverting()"
            >
              上传
            </el-button>
            <el-button
              class="normal-btn gr8"
              v-if="isChecked('Project.Single.Metadata.Bim.Download')"
              size="small"
              @click="batchDownloadFiles"
              :disabled="isConverting()"
            >
              批量下载
            </el-button>
            <el-button
              class="normal-btn gr8"
              size="small"
              @click="deleteFiles"
              :disabled="isConverting()"
              v-if="isChecked('Project.Single.Metadata.Bim.Delete')"
            >
              批量删除
            </el-button>
            <el-tooltip
            :effect="$theme.tooltipKey()"
              v-if="isLinkModel"
              placement="top-start"
              popper-class="common-tooltip-box"
            >
              <div slot="content">
                一个模型组仅支持指定一个主文件，转换成功的模型组，主文件不支持修改和删除
              </div>
              <el-button
                class="normal-btn"
                size="small"
                @click="setPrimaryFile"
                :disabled="isConverting()"
                v-if="isChecked('Project.Single.Metadata.Bim.Delete')"
              >
                设置主文件
              </el-button>
            </el-tooltip>
          </div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              v-model="keywords"
              placeholder="请输入文件名称"
              clearable
              @clear="search"
              @keyup.enter.native="search"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="search"
              />
            </el-input>
          </div>
        </div>
        <div class="tip-box public-tips-primary" v-if="isLinkModel">
          注：为保证整体效果，无链接关系的模型不参与转换
        </div>
        <div class="common-table-box">
          <el-table
            highlight-selection-row
            class="publish-table publish-small-table"
            ref="fileTable"
            :data="fileList"
            height="100%"
            @select="selectChange"
            @select-all="selectChange"
            @cell-click="handleClick"
          >
            <el-table-column type="selection" width="65" />
            <el-table-column label="序号" type="index" width="75" />
            <el-table-column label="名称">
              <template v-slot="{ row }">
                <div class="icon-column">
                  <div>
                    <span v-if="modelVersion > 0">
                      <icon-svg
                        v-if="row.changeType === 1"
                        title="当前文件为新增文件,请将该模型组重新提交转换"
                        class="icon-update"
                        icon-class="ic-add"
                      />
                      <icon-svg
                        v-else-if="row.changeType === 2"
                        title="当前文件有更新,请将该模型组重新提交转换"
                        class="icon-update"
                        icon-class="ic-jiancegengxin"
                      />
                    </span>
                    <span v-if="row.convertStatus === 1">
                      <icon-svg
                        class="icon-update"
                        :title="`本次转换中转换失败，失败原因是${row.convertError}`"
                        icon-class="ic--s-tishi"
                      />
                    </span>
                  </div>
                  <span class="text-overflow" :title="row.fileName">
                    {{ row.fileName }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="链接关系" v-if="isLinkModel" width="120">
              <template v-slot="{ row }">
                <div v-if="row.isLinkMain" class="link-box mainFile">
                  <div class="icon-box">
                    <icon-svg size="16" icon-class="ic-zhushitu" />
                  </div>
                  <div class="type-name">主文件</div>
                </div>
                <div v-else>
                  <div v-if="row.isLinkEffective" class="link-box linkFile">
                    链接文件
                  </div>
                  <div v-else class="no-link-box">无链接关系</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="大小" width="120">
              <template v-slot="{ row }">
                <span>
                  {{
                    `${formatFileSize(row.length).fileSize}${
                      formatFileSize(row.length).unit
                    }`
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="创建日期" width="180">
              <template v-slot="{ row }">
                <span>{{ formatTime(row.uploadTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template v-slot="{ row }">
                <div class="common-button-box operation-cell">
                  <div v-if="isChecked('Project.Single.Metadata.Bim.ReUpload')">
                    <el-button
                      type="text"
                      size="small"
                      v-if="isConverting()"
                      :disabled="true"
                    >
                      更新
                    </el-button>
                    <el-button
                      v-show="!isConverting()"
                      type="text"
                      size="small"
                      class="upload-text-btn"
                      :id="`refresh-${row.fileId}`"
                      @click="reUpload(row)"
                    >
                      更新
                    </el-button>
                  </div>
                  <div v-if="isChecked('Project.Single.Metadata.Bim.Download')">
                    <el-button
                      type="text"
                      size="small"
                      :disabled="isConverting()"
                      @click="downloadFileById(row)"
                    >
                      下载
                    </el-button>
                  </div>
                  <div v-if="isChecked('Project.Single.Metadata.Bim.Delete')">
                    <el-button
                      type="text"
                      size="small"
                      :disabled="isConverting()"
                      @click="deleteFileById(row)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="common-empty-box">
                <bj-empty
                  class="empty-page"
                >
                  <template>
                    <div class="empty-text nodata">抱歉，没有找到相关内容</div>
                  </template>
                </bj-empty>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import { formatFileSize, formatTime, getToken } from "@/utils/generalMethods";
import { Store } from "@/utils/store";

import {
  setLinkMainFileService,
  getBimDatasetFiles,
  deleteBimFiles,
} from "@/service/interface";

export default {
  data() {
    return {
      keywords: "",
      fileList: [],
      selectFiles: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  props: {
    visible: Boolean,
    title: String,
    isLinkModel: Boolean,
    nodeId: String,
    modelVersion: Number,
    status: Number,
    customUploader: Object,
    refreshDataSetTable: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.updateDataList();

        this.customUploader.setCurrNodeType(2);
        this.customUploader.setCurrDataSetId(this.nodeId);
        this.$nextTick(() => {
          let uploadDom = document.getElementById("model-group-upload");
          if (uploadDom) {
            let child = uploadDom.children[0];
            if (!child.className.includes("webuploader-pick")) {
              this.customUploader.uploader.addButton({
                id: "#model-group-upload",
              });
            }
          }
        });
      } else {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    },
  },
  mounted() {
    this.$eventManage.on("refreshTable", this.refreshFileTable);
  },
  beforeDestroy() {
    this.$eventManage.off("refreshTable", this.refreshFileTable);
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.updateDataList();
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.updateDataList();
    },
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.updateDataList();
    },
    refreshFileTable() {
      let domRef = this.$refs.fileTable;
      if (domRef) {
        this.updateDataList(1).then(() => {
          this.refreshDataSetTable();
        });
      }
    },
    updateDataList(page) {
      return new Promise((resolve) => {
        if (page) {
          this.currentPage = page;
        }
        let params = {
          dataSetId: this.nodeId,
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize,
          status: [4],
          fileName: this.keywords,
        };
        getBimDatasetFiles(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let fileList = data.items;
            fileList.forEach((item) => {
              item["datasetId"] = item.dataSetId;
              item["schemeType"] = item.scheme;
            });
            this.fileList = fileList;
            this.total = data.totalCount;
            this.selectFiles = [];

            this.$nextTick(() => {
              this.refeshDom();
            });
            resolve(data.totalCount);
          } else {
            resolve(0);
          }
        });
      });
    },
    reUpload(fileInfo) {
      this.customUploader.setStatus("update");
      this.customUploader.setCurrNodeType(2);
      this.customUploader.setCurrDataSetId(fileInfo.datasetId);
      fileInfo.formatType = 2;
      this.customUploader.setCurrFileInfo(fileInfo);
    },
    setPrimaryFile() {
      let selectFiles = this.selectFiles;
      if (!selectFiles.length) {
        this.$message.warning("请先勾选文件");
        return;
      }

      if (selectFiles.length > 1) {
        this.$message.warning("只能设置一个文件为主文件，请重新选择");
        return;
      }

      let fileInfo = selectFiles[0];
      let params = { fileId: fileInfo.fileId };
      setLinkMainFileService(params).then((response) => {
        if (response.isSuccess) {
          this.updateDataList().then(() => {
            this.$message.success("设置成功");
          });
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    batchDownloadFiles() {
      let selectFiles = this.selectFiles;
      if (selectFiles.length) {
        let fileData = this.selectFiles;
        this.customUploader.fire("fileDownload", { fileData });
      } else {
        this.$message.warning("请先勾选文件");
      }
    },
    downloadFileById(fileInfo) {
      let fileData = [fileInfo];
      this.customUploader.fire("fileDownload", { fileData });
    },
    deleteFiles() {
      let selectFiles = this.selectFiles;
      if (selectFiles.length) {
        this.$confirm("删除后需要重新上传，确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let fileIds = selectFiles.map((item) => item.fileId);
            let params = {
              dataSetId: this.nodeId,
              fileIds,
            };
            deleteBimFiles(params).then((response) => {
              if (response.isSuccess) {
                this.currentPage = 1;
                this.updateDataList().then(() => {
                  this.refreshDataSetTable();
                  this.$message.success("删除成功!");
                });
              } else {
                this.$message.error(response.errMsg);
              }
            });
          })
          .catch(() => {
            // this.$message.info("取消删除");
          });
      } else {
        this.$message.warning("请先勾选文件");
      }
    },
    deleteFileById(fileInfo) {
      this.$confirm("删除后需要重新上传，确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            dataSetId: this.nodeId,
            fileIds: [fileInfo.fileId],
          };
          deleteBimFiles(params).then((response) => {
            if (response.isSuccess) {
              this.currentPage = 1;
              this.updateDataList().then((total) => {
                this.refreshDataSetTable();
                this.$message.success("删除成功!");
                this.$nextTick(() => {
                  this.refeshDom();
                });
              });
            } else {
              this.$message.error(response.errMsg);
            }
          });
        })
        .catch(() => {
          // this.$message.info("取消删除");
        });
    },
    handleClick(dataInfo, column) {
      // if (column.label === '操作' || column.type === 'selection') return
      // this.$refs.fileTable.toggleRowSelection(dataInfo)
    },
    selectChange(selection) {
      this.selectFiles = selection;
    },
    refeshDom() {
      let fileList = this.fileList;

      fileList.forEach((item) => {
        let refreshDom = document.getElementById(`refresh-${item.fileId}`);
        if (refreshDom) {
          let child = refreshDom.children[0];
          if (!child.className.includes("webuploader-pick")) {
            this.customUploader.uploader.addButton({
              id: `#refresh-${item.fileId}`,
              multiple: false,
            });
          }
        }
      });
    },
    isConverting() {
      if (this.status) {
        return this.status === 1 || this.status === 2;
      } else {
        return false;
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
    formatFileSize,
    formatTime,
    getToken,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
/deep/ .dialog-box {
  height: 500px;
  min-width: 820px;
  min-height: 500px;

  .dialog-content {
    height: calc(100% - 45px);
    user-select: none;
  }
}

.file-table-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .operation-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .common-button-box {
      // :deep(.el-button) {
      //   margin-left: 0px;

      //   &:not(:last-child){
      //     margin-right: 8px;
      //   }
      // }

      // .el-button--default {
      //   border-color: #929292;
      //   background: transparent;

      //   &:hover {
      //     background: rgba(255, 255, 255, 0.2);
      //   }
      // }
    }

    /deep/ .upload-btn {
      .webuploader-pick {
        margin: -2px 0px;
      }
    }
  }

  .tip-box {
    // font-size: 14px;
    margin: 10px 0px;
    // color: #aaaaaa;
    color: var(--page-tips-text-color);
  }

  .common-table-box {
    flex-grow: 1;
    min-height: 0;

    .icon-column {
      display: flex;
      align-items: center;

      .operation-refresh {
      }
      .icon {
        margin-right: 10px;
      }

      .icon-update {
        margin-right: 10px;
        font-size: 16px;
        color: #1afa29;
      }
    }

    .link-box {
      display: inline-flex;
      align-items: center;
      padding: 0 8px;
      font-size: 12px;
      border-radius: 4px;
      line-height: 22px;

      .icon-box {
        margin-right: 5px;
        font-size: 16px;
        color: var(--base-primary-bgColor);
      }
    }

    .mainFile {
      color: var(--base-primary-bgColor);
      border: 1px solid var(--base-primary-bgColor);
      background-color: var(--base-bg-light-color24);
    }

    .linkFile {
      color: var(--base-bg-light-color55);
      border: 1px solid var(--base-bg-light-color55);
      background-color: var(--base-bg-light-color56);
    }

    .no-link-box {
      display: inline-flex;
      padding: 0 8px;
      font-size: 12px;
      color: var(--modegroup-nolink-text-color);
      border-radius: 4px;
      border: 1px solid var(--modegroup-nolink-border-color);
      background: var(--modegroup-nolink-bgColor);
      line-height: 22px;
    }

    .common-button-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: -10px;

      :deep(.webuploader-pick) {
        margin-top: 4px;
      }
    }
  }

  .common-pagination-box {
    width: 100%;
    text-align: center;
  }
}
.file-dialog {
  :deep(.dialog-content) {
    height: calc(100% - 40px);
    padding-bottom: 0;
  }
}

.pagination-primary {
  padding: 0;
}
</style>
